import { legalDocuments, requiredAssistedAffiliationFields } from "./constants";
import type {
  AssistedAffiliationFieldName,
  AssistedAffiliationFiles,
  AssistedAffiliationForm,
  LegalDocumentFiles,
  SingleAssistedAffiliationFileName,
} from "./types";

export const getMissingRequiredData = (
  form: AssistedAffiliationForm,
  files: AssistedAffiliationFiles,
  legalDocumentFiles: LegalDocumentFiles
) => {
  const requiredFields: AssistedAffiliationFieldName[] = [
    ...requiredAssistedAffiliationFields,
    ...(form.isForeignRepresentative
      ? ["nationality", "passportNumber"] as const
      : ["identityNumber"] as const),
  ];
  const requiredFiles: SingleAssistedAffiliationFileName[] = [
    ...(form.isForeignRepresentative
      ? ["passportPhoto"] as const
      : ["frontIdentification", "backIdentification"] as const),
    "accountEvidence",
  ];
  const missingRequiredFields = requiredFields.filter((field) => {
    const value = form[field];
    return typeof value === "boolean" ? !value : !String(value).trim();
  });
  const missingRequiredFiles = requiredFiles.filter((field) => !files[field]);
  const missingRequiredLegalDocuments = legalDocuments.filter(
    (document) => document.required && !legalDocumentFiles[document.field].length
  );

  return {
    missingRequiredFields,
    missingRequiredFiles,
    missingRequiredLegalDocuments,
    hasMissingRequiredData: Boolean(
      missingRequiredFields.length || missingRequiredFiles.length ||
      missingRequiredLegalDocuments.length
    ),
  };
};
